import { Tool } from "lib/types/Tool";
import { ViewToolsState } from "lib/types/views/ViewToolsState";

export type ViewToolsStateKey = Exclude<keyof ViewToolsState, "version">;

/** The subset of `Tool` values that have a corresponding `ViewToolsState` entry. */
export type ViewsTool = Extract<Tool, ViewToolsStateKey>;

const toolSet = new Set<Tool>([
  Tool.visibility,
  Tool.clippingBox,
  Tool.opacity,
  Tool.search,
  Tool.paint,
  Tool.coordinates,
  Tool.measure,
  Tool.drawPolygon,
] satisfies ViewsTool[]);

export const viewsToolSet = toolSet as ReadonlySet<ViewsTool>;

export function isViewsTool(tool: Tool): tool is ViewsTool {
  return toolSet.has(tool);
}

export function getViewToolsStateToolKey(tool: ViewsTool): ViewToolsStateKey {
  return tool;
}
